import { render } from "./tdcRequestDetails.vue?vue&type=template&id=61615e32&scoped=true"
import script from "./tdcRequestDetails.vue?vue&type=script&lang=js"
export * from "./tdcRequestDetails.vue?vue&type=script&lang=js"

import "./tdcRequestDetails.vue?vue&type=style&index=0&id=61615e32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61615e32"]])

export default __exports__